import groq from 'groq';

import { querySingletonDoc } from './querySingletonDoc';
import { RICH_TEXT } from './richText';

const FULLSCREEN_POPUP_FIELDS = groq`
  _updatedAt,
  isPopupEnabled,
  name,
  variant,
  videos {
    desktop {
      "_type": "gif",
      "cloudinaryId": public_id,
    },
    mobile {
      "_type": "gif",
      "cloudinaryId": public_id,
    }
  },
  delay,
  overlineText,
  title[] {
    ${RICH_TEXT}
  },
  link {
    href,
    title
  }
`;

export const FULLSCREEN_POPUP = groq`
  ${querySingletonDoc('timeline_fullscreenPopup', 'fullscreenPopupDoc')} {
    ${FULLSCREEN_POPUP_FIELDS}
  }
`;

export const SKINCARE_FULLSCREEN_POPUP = groq`
  ${querySingletonDoc('timeline_fullscreenPopup', 'skincare_fullscreenPopupDoc')} {
    ${FULLSCREEN_POPUP_FIELDS}
  }
`;
